module.exports = __webpack_public_path__ + "components/flag/static/square/kp-8907b0a06cfc326bf2cf8fc6110478a7.svg";